import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Hook pour détecter si l'application tourne sur une plateforme native
 */
export const useCapacitor = () => {
  const [isNative, setIsNative] = useState(false);
  const [platform, setPlatform] = useState<'ios' | 'android' | 'web'>('web');

  useEffect(() => {
    const native = Capacitor.isNativePlatform();
    const currentPlatform = Capacitor.getPlatform();
    
    setIsNative(native);
    setPlatform(currentPlatform as 'ios' | 'android' | 'web');
  }, []);

  return {
    isNative,
    platform,
    isIOS: platform === 'ios',
    isAndroid: platform === 'android',
    isWeb: platform === 'web'
  };
};

/**
 * Hook pour gérer les fonctionnalités natives
 */
export const useNativeCapabilities = () => {
  const { isNative } = useCapacitor();

  return {
    hasCamera: isNative,
    hasGeolocation: isNative,
    hasPushNotifications: isNative,
    hasHaptics: isNative
  };
};
